import * as paymentActions from 'client/actions/paymentActions'
import { wrapFontFamily } from 'common/components/entities/Text/utils'
import { NotFound } from 'common/errors'
import { NetworkError } from 'common/errors/NetworkError'
import { useActions } from 'common/hooks/useActions'
import PropTypes from 'prop-types'
import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypography } from 'src/editor/shared/hooks/use-typography'
import { ActivePopup } from './components/popup/active-popup'
import PageUi from './ui/PageUi'

function PaymentPage({ children }) {
  const dispatch = useDispatch()
  const { globalFontFamily, globalFontStyle, globalFontWeight } =
    useTypography()
  const fetchPaymentData = useActions(paymentActions.fetchPaymentData)

  useEffect(() => {
    ;(async () => {
      try {
        const { data } = await fetchPaymentData()
        dispatch(paymentActions.fetchPaymentDataSuccess(data))
      } catch (error) {
        if (error instanceof NotFound) {
          // do nothing
        } else if (error instanceof NetworkError) {
          // do nothing, we have stub data
        } else {
          // do nothing
        }
      }
    })()
  }, [])

  return (
    <PageUi
      fontFamily={wrapFontFamily(globalFontFamily)}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
      <ActivePopup />
    </PageUi>
  )
}

PaymentPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default memo(PaymentPage)
